import { buttonBaseClasses } from '@mui/material'
import { css, Theme } from '@emotion/react'
import { scaleBorderRadius } from 'theme/utils'

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 24px;
`

export const filtersSection = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`

export const tableSection = css`
  width: 100%;
`

export const addPartnershipButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(3)};
  width: 100%;
`

export const actionButton = (theme: Theme) => css`
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 2.5)};
`

export const footerWrapper = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  gap: 16px;
`

export const codeText = (theme: Theme) => css`
  padding: 8px 12px;
  background: ${theme.backgrounds.backgroundFive};
  border-radius: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${theme.typographyColors.typographyTwo};
  font-size: 14px;
  font-weight: 700;
  word-wrap: break-word;
  text-align: center;
  width: 100%;
  min-height: 34px;
`

export const deleteCodeButton = css`
  &.${buttonBaseClasses.root} {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`

export const generateCodeButton = (theme: Theme) => css`
  padding: 8px 12px;
  background: ${theme.colors.blue};
  border-radius: 8px;
  border: none;
  color: white;
  font-size: 14px;
  min-height: 34px;
  font-weight: 700;
  text-transform: none;
  width: 100%;
  height: auto;
  box-shadow: none;
`
